import { COLORS } from '@/styles/colorTheme';
import { Newspaper } from 'lucide-react';

const NewsIcon = ({ state = 'mouseup', isSelected = false }) => {
  let color = COLORS.Text400;
  if (state === 'mousedown') color = '#fff';

  return (
    <>
      <Newspaper size={22} color={color} strokeWidth={1.5} />
    </>
  );
};

export default NewsIcon;
